import { Box } from '@mui/material';

interface Patient360TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const Patient360TabPanel = ({ children, value, index, ...other }: Patient360TabPanelProps) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`patient-360-tabpanel-${index}`}
    aria-labelledby={`patient-360-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
  </div>
);